import { render } from "./ManipulacionAlimentos.vue?vue&type=template&id=7fc49764&scoped=true"
import script from "./ManipulacionAlimentos.vue?vue&type=script&lang=js"
export * from "./ManipulacionAlimentos.vue?vue&type=script&lang=js"

import "./ManipulacionAlimentos.vue?vue&type=style&index=0&id=7fc49764&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc49764"]])

export default __exports__